import React, { useState } from "react";

import "./App.css";
import axios from "axios";
import { Field, Form, Formik, useFormikContext } from "formik";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Step,
  StepLabel,
  Stepper,
  Select,
  Typography,
} from "@mui/material";
import { TextField } from "formik-material-ui";
import * as Yup from "yup";
import { cnpj, cpf } from "cpf-cnpj-validator";
import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const api = axios.create({
  baseURL: process.env.REACT_APP_HOST_API,
});

function App() {
  const [formaPgto, setFormaPgto] = useState("I");
  const [cpfInformado, setCpfInformado] = useState("");
  const [tagEnabledSubmit, setTagEnabledSubmit] = useState(true);
  const [tipoPessoa, setTipoPessoa] = useState("F");

  const handleChange = (event) => {
    setFormaPgto(event.target.value);
  };

  const downloadBoleto = async (values) => {
    const { inputCpf } = values;
    await api
      .get(
        `/file/download/${
          process.env.REACT_APP_NUMERO_CONSELHO
        }_${inputCpf.replace(
          /([^\d])+/gim,
          ""
        )}_${formaPgto}_${tipoPessoa}.pdf`,
        { responseType: "blob" }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "anuidade.pdf");
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        toast.error("ops! Boleto não localizado, favor entrar em contato.");
      });
  };

  const cpfErrorMessagesSchema = Yup.object().shape({
    inputCpf: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Informação obrigatória")
      .test(
        "inputCpf",
        tipoPessoa === "F" ? "CPF Inválido" : "CNPJ Inválido",
        (value) =>
          tipoPessoa === "F" ? cpf.isValid(value) : cnpj.isValid(value)
      ),
  });

  const AtualizaState = () => {
    const { values } = useFormikContext();

    const { inputCpf } = values;
    setCpfInformado(inputCpf);
  };

  function onChange(value) {
    setTagEnabledSubmit(true);
  }

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h6" sx={{ my: 2 }}>
          {process.env.REACT_APP_TITULO}
        </Typography>
        <Divider />
        <Card>
          <CardContent>
            <FormikStepper
              initialValues={{
                inputCpf: "",
              }}
              onSubmit={async (values) => {
                tagEnabledSubmit === false
                  ? alert("Captcha não informado")
                  : await downloadBoleto(values);
              }}
            >
              <FormikStep
                label="Informações pessoais"
                validationSchema={cpfErrorMessagesSchema}
              >
                <Box paddingBottom={2} paddingTop={5}>
                  <Field
                    fullWidth
                    name="inputCpf"
                    component={TextField}
                    label={
                      tipoPessoa === "F"
                        ? "Profissional informe o seu CPF"
                        : "Empresa informe o seu CNPJ"
                    }
                  />

                  <Button
                    variant="text"
                    onClick={() =>
                      tipoPessoa === "F"
                        ? setTipoPessoa("J")
                        : setTipoPessoa("F")
                    }
                  >
                    Para emitir anuidade para empresa clique aqui
                  </Button>
                </Box>
              </FormikStep>
              <FormikStep label="Forma de Pagamento">
                <Box paddingBottom={2} paddingTop={5}>
                  <FormControl fullWidth>
                    <InputLabel id="txtFormaPagamento">
                      Forma de Pagamento
                    </InputLabel>
                    <Select
                      labelId="txtFormaPagamento"
                      id="txtFormaPagamento"
                      label="Forma de Pagamento"
                      value={formaPgto}
                      onChange={handleChange}
                    >
                      <MenuItem value={""}></MenuItem>
                      <MenuItem value={"I"}>Integral</MenuItem>
                      <MenuItem value={"P"}>
                        Parcelado - Apenas para quem pagou a primeira parcela
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </FormikStep>
              <FormikStep label="Download Boleto">
                <Box paddingBottom={2} paddingTop={5}>
                  <InputLabel id="lblMostraCpf">
                    {tipoPessoa === "F" ? "CPF" : "CNPJ"} informado:{" "}
                    {cpfInformado}
                  </InputLabel>
                  <InputLabel id="lblFormaPagamento">
                    Forma de Pagamento:{" "}
                    {formaPgto === "I"
                      ? "Pagamento Integral"
                      : "Pagamento Parcelado"}
                  </InputLabel>
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_SITE_KEY_CAPCTHA}
                    onChange={onChange}
                  />
                </Box>
                <AtualizaState />
              </FormikStep>
            </FormikStepper>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
export function FormikStep({ children }) {
  return <>{children}</>;
}

export function FormikStepper({ children, ...props }) {
  const childrenArray = React.Children.toArray(children);
  const [step, setStep] = useState(0);
  const currentChild = childrenArray[step];
  const [completed, setCompleted] = useState(false);

  function isLastStep() {
    return step === childrenArray.length - 1;
  }

  return (
    <Formik
      {...props}
      validationSchema={currentChild.props.validationSchema}
      onSubmit={async (values, helpers) => {
        if (isLastStep()) {
          await props.onSubmit(values, helpers);
          setCompleted(true);
        } else {
          setStep((s) => s + 1);

          // the next line was not covered in the youtube video
          //
          // If you have multiple fields on the same step
          // we will see they show the validation error all at the same time after the first step!
          //
          // If you want to keep that behaviour, then, comment the next line :)
          // If you want the second/third/fourth/etc steps with the same behaviour
          //    as the first step regarding validation errors, then the next line is for you! =)
          //
          // In the example of the video, it doesn't make any difference, because we only
          //    have one field with validation in the second step :)
          helpers.setTouched({});
        }
      }}
    >
      {({ isSubmitting }) => (
        <Form autoComplete="off">
          <Stepper alternativeLabel activeStep={step}>
            {childrenArray.map((child, index) => (
              <Step
                key={child.props.label}
                completed={step > index || completed}
              >
                <StepLabel>{child.props.label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {currentChild}

          <Grid container spacing={2}>
            {step > 0 ? (
              <Grid item>
                <Button
                  disabled={isSubmitting}
                  variant="contained"
                  color="primary"
                  onClick={() => setStep((s) => s - 1)}
                >
                  Voltar
                </Button>
              </Grid>
            ) : null}
            <Grid item>
              <Button
                startIcon={
                  isSubmitting ? <CircularProgress size="1rem" /> : null
                }
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                type="submit"
              >
                {isSubmitting
                  ? "Processando"
                  : isLastStep()
                  ? "Gerar boleto"
                  : "Próximo"}
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

export default App;
